<template>
  <BaseSimpleLayout class="master-product-edit">
    <template #title>製品編集</template>
    <template v-if="loadingFlag" #main>
      <el-form
        ref="formRef"
        :model="editForm"
        :rules="rules"
        size="large"
        label-width="100px"
      >
        <el-form-item class="unit-master-product-edit-id" label="ID" prop="id">
          <el-input v-model="editForm.id" autocomplete="off" disabled />
        </el-form-item>
        <el-form-item
          class="unit-master-product-edit-name"
          label="製品名称"
          prop="name"
        >
          <el-input
            v-model="editForm.name"
            autocomplete="off"
            :disabled="isConfirm"
          />
        </el-form-item>
        <el-form-item
          class="unit-master-product-edit-productCode"
          label="品番"
          prop="productCode"
        >
          <el-input
            v-model="editForm.productCode"
            autocomplete="off"
            :disabled="isConfirm"
          />
        </el-form-item>
        <el-form-item
          class="unit-master-product-edit-jan"
          label="JAN"
          prop="jan"
        >
          <el-input
            v-model="editForm.jan"
            autocomplete="off"
            :disabled="isConfirm"
          />
        </el-form-item>
        <el-form-item
          label="製品種別"
          prop="productType"
          class="product-input-type"
        >
          <el-select
            v-model="editForm.productType"
            placeholder="選択"
            :disabled="isConfirm"
          >
            <el-option
              v-for="productType in productTypeList"
              :key="productType.val"
              :label="productType.label"
              :value="productType.val"
            />
          </el-select>
        </el-form-item>
        <el-form-item class="product-input-price" label="費用(円)" prop="price">
          <el-input-number
            v-model="editForm.price"
            :precision="0"
            :min="0"
            :controls="false"
            :disabled="isConfirm"
          />
        </el-form-item>
        <el-form-item
          label="MCCS ver"
          prop="MCCSver"
          class="product-input-type"
        >
          <el-select
            v-model="editForm.deviceType"
            placeholder="(選択なし)"
            :disabled="isConfirm"
          >
            <el-option
              v-for="deviceType in deviceTypeList2"
              :key="deviceType.val"
              :label="deviceType.label"
              :value="deviceType.val"
            />
          </el-select>
        </el-form-item>
      </el-form>
      <el-button
        v-if="editForm.productType < 3"
        type="success"
        class="product-edit-button-add-package"
        size="large"
        :disabled="isConfirm"
        @click="dialogFormVisible = true"
      >
        パッケージ追加
      </el-button>
      <el-table
        v-if="editForm.productType < 3"
        :data="editForm.details"
        stripe
        border
        style="width: 700px"
        class="unit-master-product-create-details-table"
        empty-text="組付パッケージが存在しません"
      >
        <el-table-column
          prop="packId"
          label="ID"
          class-name="unit-master-product-details-name"
          width="60px"
          align="center"
        />
        <el-table-column
          prop="packName"
          label="パッケージ名"
          class-name="unit-master-product-details-name"
        >
          <template #default="scope">
            <span>{{ packageNameChanger[scope.row.packId] }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="packQty"
          label="個数"
          width="60px"
          align="center"
          class-name="unit-master-product-details-qty"
        />
        <el-table-column
          label="操作"
          width="85px"
          align="center"
          class-name="unit-master-product-details-ope"
        >
          <template #default="scope">
            <el-button
              type="danger"
              class="unit-master-product-details-button-delete"
              :disabled="isConfirm"
              @click="deletePackage(scope.$index)"
            >
              削除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <div v-if="isConfirm" class="product-edit-button-area">
        <el-button size="large" type="info" @click="isConfirm = false">
          戻る
        </el-button>
        <el-button size="large" type="primary" @click="update()">
          更新
        </el-button>
      </div>
      <div v-else class="product-edit-button-area">
        <el-button
          size="large"
          type="info"
          @click="router.push(`/master/product/${editForm.id}`)"
        >
          戻る
        </el-button>
        <el-button size="large" type="primary" @click="changeConfirm(formRef)">
          確認
        </el-button>
      </div>
      <el-dialog
        v-model="dialogFormVisible"
        title="組付パッケージ登録"
        width="500px"
      >
        <el-form
          size="large"
          :model="packageForm"
          class="product-edit-details-form"
        >
          <el-form-item label="パッケージ名" label-width="130px">
            <el-select
              v-model="packageForm.packId"
              filterable
              placeholder="Select"
              class="product-edit-details-id-input"
            >
              <el-option
                v-for="option in packageList"
                :key="option.id"
                :label="option.name"
                :value="option.id"
              />
            </el-select>
          </el-form-item>
          <el-form-item
            label="個数"
            label-width="130px"
            class="product-input-pack-qty"
          >
            <el-input-number
              v-model="packageForm.packQty"
              :precision="0"
              :min="1"
              :controls="false"
            />
          </el-form-item>
        </el-form>
        <template #footer>
          <el-button size="large" @click="dialogFormVisible = false">
            キャンセル
          </el-button>
          <el-button size="large" type="primary" @click="addPackage">
            追加
          </el-button>
        </template>
      </el-dialog>
    </template>
  </BaseSimpleLayout>
</template>

<script setup lang="ts">
  import { ref } from 'vue';
  import { useStore } from 'vuex';
  import router from '@/router';
  import BaseSimpleLayout from '@/components/BaseSimpleLayout.vue';
  import type { FormInstance, FormRules } from 'element-plus';
  import { ProductPutDataState, AddPackageData } from '@/types/master/product';
  import {
    PackagesDataState,
    PackageReplaceNameData
  } from '@/types/master/package';
  import { productTypeList, deviceTypeList2 } from '@/libs/product';

  import { ElLoading } from 'element-plus';

  const store = useStore();
  const formRef = ref<FormInstance>();
  const dialogFormVisible = ref(false);
  const editForm = ref<ProductPutDataState>({
    id: 0,
    name: '',
    productCode: '',
    jan: null,
    price: 0,
    productType: 1,
    deviceType: null,
    details: []
  });
  const packageForm = ref<AddPackageData>({
    packId: null,
    packQty: 1
  });
  const rules = ref<FormRules>({
    name: [{ required: true, message: '製品名称は必須です。' }],
    price: [{ required: true, message: '製品価格は必須です。' }],
    productType: [{ required: true, message: '製品種別は必須です。' }]
  });
  const packageList = ref<PackagesDataState[]>([]);
  const packageNameChanger = ref<PackageReplaceNameData>({});
  const loadingFlag = ref(false);
  const isConfirm = ref(false);

  const initialize = async () => {
    const putData = store.state.productMaster.putData;
    if (!putData) {
      return router.push('/master/product');
    }
    const loadingInstance = ElLoading.service({ fullscreen: true });
    editForm.value = putData;
    await store.dispatch('packagesMaster/fetch');
    packageList.value = store.state.packagesMaster.listData;
    packageForm.value.packId = packageList.value[0].id;
    packageNameChanger.value = store.state.packagesMaster.replaceData;
    loadingInstance.close();
    loadingFlag.value = true;
  };
  const changeConfirm = async (formEl: FormInstance | undefined) => {
    if (!formEl) return;
    formEl.validate((valid: boolean) => {
      if (!valid) {
        return false;
      }
      if (editForm.value.productType > 2) editForm.value.details = [];
      isConfirm.value = true;
    });
  };
  const update = () => {
    store.dispatch('productMaster/put', editForm.value);
  };
  const addPackage = () => {
    editForm.value.details.push(packageForm.value);
    dialogFormVisible.value = false;
    packageForm.value = {
      packId: packageList.value[0].id,
      packQty: 1
    };
  };
  const deletePackage = (index: number) => {
    editForm.value.details.splice(index, 1);
  };
  initialize();
</script>
<style lang="scss">
  .master-product-edit {
    .el-button {
      font-weight: 600;
    }
    form {
      width: 500px;
      margin: auto;
    }
    .el-form-item {
      font-weight: 600 !important;
    }
    .product-edit-details-form {
      width: 500px;
    }

    .product-edit-button-add-package {
      margin-bottom: 20px;
    }

    .product-edit-details-id-input {
      float: left;
      width: 300px;
    }

    .product-edit-details-qty-input {
      float: left;
      width: 65px;
    }

    .product-edit-details-error-text {
      color: #f56c6c;
      font-size: 12px;
      line-height: 1;
      padding-top: 4px;
      position: absolute;
    }

    .el-table {
      margin-bottom: 20px;
    }

    .product-input-price {
      .el-input-number {
        float: left;
        width: 160px;
      }
      input {
        text-align: left;
      }
    }
    .product-input-type {
      .el-select {
        width: 160px;
        float: left;
      }
    }
    .product-input-pack-qty {
      .el-input-number {
        float: left;
        width: 60px;
      }
    }
    .product-edit-button-area {
      margin: 10px 0;
    }
    .el-table__header-wrapper {
      th {
        background-color: #f5f7fa;
      }
    }
    .el-table {
      margin: auto;
    }
    td {
      div {
        font-weight: 600;
      }
    }
  }
</style>
